<script>
    import { state, res, ui, prefs } from './stores.js';
    import { doAction, logText } from './game.js';

    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling
    import { onMount } from 'svelte';
    import { cardOwner } from './parse.js';
    import { getIconURL } from './card_images.js';
    import { trackTypes } from './card_actions.js';

    export let r;
    export let p;
	export let card = false;
	export let min = 0;
	export let max = Infinity;
	export let editable = true;
	
    let amount;
    let tip;
	let editInput;

	//console.log(p[r])

	$: if(!p[r]) p[r] = 0;

    $: amount = p[r]; // why isn't parseInt working?

    export let opacity = 1;
    export let size = 20;
	export let hideIfEmpty = false;
    export let colour = 'white';
    export let boolean = false;
    export let click = async (change) => {
		// TODO !!! add undo save here
		if(!p[r]) p[r] = 0;
		change = parseInt(change);
		p[r] = parseInt(p[r]);
		if(p[r] + change < min || p[r] + change > max) return;
		try{
			if(card){
				await doAction(cardOwner(p), 'token_on_card', {card: p.uniqueID, token: r, amount: change}); // Nothing can go into negative
			}else{
				if(change > 0){
					if(trackTypes(p).includes(r)){
						await doAction(p, 'gain_track', {track: r, amount: change, manual: true}); // Nothing can go into negative
					}else{
						await doAction(p, 'gain_tokens', {token: r, amount: change, manual: true}); // Nothing can go into negative
					}

				}else{
					if(trackTypes(p).includes(r)){
						await doAction(p, 'spend_track', {track: r, amount: Math.abs(change), manual: true}); // Nothing can go into negative
					}else{
						await doAction(p, 'spend_tokens', {token: r, amount: Math.abs(change), manual: true}); // Nothing can go into negative
					}

				}

			}
		}catch(e){
			if(e == 'uncompleted'){
				logText('Action not fully completed: abandoning.', true);
			}else if(e == 'completed'){
				logText('Action counted as fully completed.', true);
			}else{
				throw e;
			}
		}
		
    }
    let editing = false;
    let editingElement;
	let editingComponent;
	let tokenComponent;
	export let canEdit = true;
	let prev = p[r] || 0;

    $: if(!p) hideIfEmpty = true;

	$: if($ui.flash.some(f => f.p == p && f.r == r)){
		$ui.flash = $ui.flash.filter(f => f.p != p || f.r != r);
		flash(tokenComponent);
	}

    onMount(() => {
		tip = tippy(tokenComponent, {
			content: editingElement,
			trigger: 'manual',
			interactive: true,
			appendTo: document.body
		});
	});

	function flash(element) {
		requestAnimationFrame(() => {
			element.style.transition = 'none';
			element.style.color = 'yellow';
			element.style.backgroundColor = 'grey';

			setTimeout(() => {
				element.style.transition = 'color 1s, background 1s';
				element.style.color = '';
				element.style.backgroundColor = '';
			});
		});
	}

    function upperInitial(r){
        if(!r) return '';
        return r[0].toUpperCase() + r.slice(1);
    }

    function checkClickOutside(event){
		var isClickInside = editingElement && editingElement.contains(event.target) || editingComponent && editingComponent.contains(event.target);
			if(!isClickInside){
				// Stop
				finishEditing();
			}
	}

    function finishEditing(){
		console.log('ue', p[r], amount)
		if(editing){
			if(typeof p[r] == 'string') p[r] = p[r].replace(/[^0-9]/g, '');
			if(isNaN(amount)) amount = 0;
			amount = parseInt(amount);
			let change = amount - p[r];
            if(change) click(change);
		}
		editing = false;
		if(tip) tip.hide();
		document.removeEventListener('click', checkClickOutside)
	}

    function updateEditing(e){
		console.log('ue', p[r], amount)
		if(editing){
			if(typeof p[r] == 'string') p[r] = p[r].replace(/[^0-9]/g, '');
			amount = p[r];
		    amount = parseInt(amount);
			if(isNaN(amount)) amount = 0;	
		}
		if(e.keyPress == 13) finishEditing();
	}


	async function editToken(element){
		if(!tip){
			tip = tippy(tokenComponent, {
				content: editingElement,
				trigger: 'manual',
				interactive: true,
				appendTo: document.body
			});
		}
		editing = true;
		if(tip) tip.show();
		if(editInput){
			editInput.focus();
			editInput.select();
		}
		document.addEventListener('click', checkClickOutside);
	} 

    function toggle(e){
		if(!editable) return;
        if(editing){
			finishEditing();
		}else if(canEdit){
			editToken(editingElement);
		}
        e.stopPropagation();
    }

	function colourStyle(_){
		if($prefs.hasOwnProperty(`${r}Colour`)){
			let amount = $prefs[`${r}Colour`];
			return `filter: hue-rotate(${amount}deg);`
		}else{
			return ''
		}
	}

</script>
<div class="tokenrow" style='opacity: {opacity}; { ((p && p[r] && p[r] > 0) || !hideIfEmpty) ? '' : 'display: none;' }' 
    on:mouseenter={e => { $ui.tokenAlteringFunction = click; } } 
    on:mousemove={e => { $ui.tokenAlteringFunction = click;} } 
    on:mouseleave={e => { $ui.tokenAlteringFunction = null;} } 
    >
    <div bind:this={tokenComponent} class="token" style="min-width: {size}vmin; min-height: {size}vmin; {canEdit ? 'cursor: pointer' : ''}; {colourStyle($prefs)}" on:click={toggle}>
        <!--{#if editing}
        <div bind:this={editingComponent} class="editcomponent" style="bottom: {size}vmin;">
            <div>
                <div class="header">{names[r]}</div>
                <div class="editblock" >
                    <button class="incdec" style="font-size: {size}vmin; min-width: {size}vmin;" on:click={e => {click(-1); e.stopPropagation();}}>-</button>
                    <input type="text" pattern="\d*" inputmode="numeric" size=2 class="tokennum" style="font-size: {size*.8}vmin;" bind:value={p[r]} min=0 on:keyup={e => {if(e.keyPress == 13) finishEditing();} } on:input={updateEditing}/>
                    <button class="incdec" style="font-size: {size}vmin; min-width: {size}vmin;;" on:click={e => {click(1); e.stopPropagation();}}>+</button>
                </div>
            </div>
        </div>
        {/if}-->
        <div class="imagediv"  style="background-image: url({getIconURL(r)})">
        </div>
            <div class="tokencount" style="font-size: {size*.8}vmin;" >
                    {p[r]}
            </div>
    </div>
</div>
<div style="display: none;">
    <div class="editcomponent" bind:this={editingElement}>
        <div class="header">{upperInitial(r)}</div>
        <div>
            <button class="change_button" style="font-size: {$prefs.buttonScale * 1.5}vmin; " on:click={e => {click(-1); e.stopPropagation();}}>-</button>
                    <input bind:this={editInput} type="text" pattern="\d*" inputmode="numeric" size=2 class="tokennum" bind:value={p[r]} {min} {max} on:keydown={e => {console.log('key', e.key, p[r]); if(e.key == 'Enter') finishEditing();} } on:input={updateEditing}/>
                    <button class="change_button" style="font-size: {$prefs.buttonScale * 1.5}vmin; " on:click={e => {click(1); e.stopPropagation();}}>+</button>
        </div>
    </div>
</div>
<style>
	.change_button {
		touch-action: manipulation;
	}

	.edit {
		display: flex;
		flex-direction: column;
		background-color: black;
		color: white;
		border: 2px solid white;
	}

	.tokenrow {
		min-height: 0;
		min-width: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		padding: 0.4vmin;
	}

    .token {
		/*display: grid;
		grid-template-columns: 1;
		justify-items: center;*/
		position: relative;
		text-align: center;

		height: 100%;
        pointer-events: all;
	}

    .tokencount {
		font-weight: bold;
		text-align: center;
		font-size: 9vmin;
		position: absolute;
		top: 50%;
		left: 50%;
		opacity: 90%;
		transform: translate(-50%, -50%);
		text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
		/*text-shadow: 0px 0px 10px black;*/
		display: flex;
		justify-content: center;
		align-items: center;
        pointer-events: all;
	}

    .imagediv {
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		position: absolute;
		opacity: 0.8;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		height: 100%;
		width: 100%;
        pointer-events: all;
	}

    button.incdec {
		background: black;
		border: 2px solid white;
		color: white;
		font-weight: bold;
		font-size: 9vmin;
		padding: 0;
		flex-grow: 1;
        pointer-events: all;
		touch-action: manipulation;
	}

	.editcomponent {
		font-weight: bold;
		text-align: center;
	}

	.editblock {
		display: flex;
		justify-content: center;
	}

	button {
		color: white;
		background-color: black;
		outline: none;
		font-weight: bold;
		font-size: 1.5vmin;
		margin: 0;
		min-width: 3vmin;
	}
</style>